import React from "react";
import NavBar from "./components/NavBar/NavBar";

const Layout = ({ children }) => (
  <>
    <NavBar />
    <main>{children}</main>
  </>
);

export default Layout;
